import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, toRefs, watch } from "vue";
import { useStore }                           from "vuex";
import { AppTheme }                           from "@greywind/ui";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const colors  = computed( () => store.state.theme.colors );
const current = computed( () => store.state.theme.current );
const user    = computed( () => store.getters[ "auth/currentUser" ] );

onMounted( async (): Promise<void> => {
    await store.dispatch( "theme/preloadTheme" );
} );

watch( () => user.value, u => {
    if ( !u.id ) return;

    store.dispatch( "theme/setTheme", u );
}, { deep: true } );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AppTheme), { colors: _unref(colors) }, null, 8, ["colors"]))
}
}

})